import { render, staticRenderFns } from "./FlotteOxilio.vue?vue&type=template&id=5faa1219&scoped=true"
import script from "./FlotteOxilio.vue?vue&type=script&lang=js"
export * from "./FlotteOxilio.vue?vue&type=script&lang=js"
import style0 from "./FlotteOxilio.vue?vue&type=style&index=0&id=5faa1219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faa1219",
  null
  
)

export default component.exports